var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 3.33341C2.96482 3.33341 2.66634 3.63189 2.66634 4.00008V13.3334C2.66634 13.7016 2.96482 14.0001 3.33301 14.0001H12.6663C13.0345 14.0001 13.333 13.7016 13.333 13.3334V4.00008C13.333 3.63189 13.0345 3.33341 12.6663 3.33341H3.33301ZM1.33301 4.00008C1.33301 2.89551 2.22844 2.00008 3.33301 2.00008H12.6663C13.7709 2.00008 14.6663 2.89551 14.6663 4.00008V13.3334C14.6663 14.438 13.7709 15.3334 12.6663 15.3334H3.33301C2.22844 15.3334 1.33301 14.438 1.33301 13.3334V4.00008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 6.66675C1.33301 6.29856 1.63148 6.00008 1.99967 6.00008H13.9997C14.3679 6.00008 14.6663 6.29856 14.6663 6.66675C14.6663 7.03494 14.3679 7.33341 13.9997 7.33341H1.99967C1.63148 7.33341 1.33301 7.03494 1.33301 6.66675Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6663 0.666748C11.0345 0.666748 11.333 0.965225 11.333 1.33341V4.00008C11.333 4.36827 11.0345 4.66675 10.6663 4.66675C10.2982 4.66675 9.99967 4.36827 9.99967 4.00008V1.33341C9.99967 0.965225 10.2982 0.666748 10.6663 0.666748Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 0.666748C5.7012 0.666748 5.99967 0.965225 5.99967 1.33341V4.00008C5.99967 4.36827 5.7012 4.66675 5.33301 4.66675C4.96482 4.66675 4.66634 4.36827 4.66634 4.00008V1.33341C4.66634 0.965225 4.96482 0.666748 5.33301 0.666748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWhite);
export default __webpack_public_path__ + "static/media/Calendar_white.287ab00ce0f677084bf850a79e6efcab.svg";
export { ForwardRef as ReactComponent };